import Entity from '../entity'

export default class Manufacturer extends Entity<number>{
    name: string;
    image: string;
    image_url: string;
    active: boolean;
}


